export const FilteredItems = {
  filterRootElement: document.getElementById('component-products-filter-root'),
  filteredItemsContainer: document.querySelector('.filtered-items'),

  // Configurações específicas para cada tipo de filtro (cor, tamanho, tag)
  filterConfigs: {
    color: {
      urlParam: 'property1_values[]',
      itemClass: 'filtered-color',
      elementSelector: '.color-value-container',
      textSelector: '.color-value-text',
      contentClass: 'filtered-color-button',
      hasColorValue: true, // Indica que possui valor de cor (hex)
    },
    size: {
      urlParam: 'property2_values[]',
      itemClass: 'filtered-size',
      elementSelector: '.list-value-container',
      textSelector: '.list-value-text span',
      contentClass: 'filtered-size-text'
    },
    tag: {
      urlParam: 'type_tags',
      itemClass: 'filtered-tag',
      elementSelector: '.list-value-container',
      textSelector: '.list-value-text span',
      contentClass: 'filtered-tag-text',
      isCategoryBased: true, // Indica que usa categoria na URL
    },
  },

  // Carrega e exibe os filtros com base nos parâmetros da URL atual
  loadFiltersFromURL() {
    const { filterConfigs, createFilterItem, getColorParam } = FilteredItems;
    const urlParams = new URL(window.location.href).searchParams;

    // Procura no filterConfigs o tipo de filtro que corresponde ao parâmetro
    for (const [paramKey, paramValue] of urlParams.entries()) {
      if (paramKey === filterConfigs.color.urlParam) {
        const { colorName, colorCode } = getColorParam(paramValue);
        createFilterItem('color', colorName, { colorCode });
      } else if (paramKey === filterConfigs.size.urlParam) {
        createFilterItem('size', paramValue);
      } else if (paramKey.startsWith(filterConfigs.tag.urlParam + '[')) {
        // Extrai a categoria - remove "type_tags[]" do parâmetro
        const cleanedCategory = paramKey.match(/type_tags\[([^\]]+)\]/)?.[1];
        cleanedCategory && createFilterItem('tag', paramValue, { category: cleanedCategory });
      }
    }
  },

  // Extrai o nome e o código hexadecimal da cor a partir do parâmetro
  getColorParam(colorParam) {
    const [namePart, colorPart] = colorParam.split('|').map(part => part.trim());
    const colorName = namePart.split(',')[0].trim();
    const colorCode = colorPart;
    return { colorName, colorCode };
  },

  // Cria um novo item de filtro
  createFilterItem(filterType, value, { colorCode, category } = {}) {
    const { filteredItemsContainer, filterConfigs, createFilterContent, removeFilter } = FilteredItems;
    const config = filterConfigs[filterType];

    const newFilteredItem = document.createElement('div');
    newFilteredItem.className = `filtered-item ${config.itemClass}`;

    const filterContent = createFilterContent(filterType, value, { colorCode, category });

    // Botão de remoção do filtro
    const removeButton = document.createElement('span');
    removeButton.className = 'filtered-item-remove';
    removeButton.textContent = '×';
    removeButton.addEventListener('click', () => removeFilter(filterType, value, category));

    newFilteredItem.append(filterContent, removeButton);
    filteredItemsContainer.appendChild(newFilteredItem);
  },

  // Gera o conteúdo visual do filtro (ex.: botão de cor ou texto)
  createFilterContent(filterType, value, { colorCode, category }) {
    const { filterConfigs } = FilteredItems;
    const config = filterConfigs[filterType];
    const displayValue = value;

    const isColorFilter = config.hasColorValue;
    const contentElement = document.createElement(isColorFilter ? 'div' : 'span');
    contentElement.className = config.contentClass;

    if (isColorFilter) {
      if (colorCode) contentElement.style.backgroundColor = colorCode;
      contentElement.setAttribute('title', displayValue); // Tooltip com o nome da cor
    } else if (filterType === 'tag' && category) {
      const capitalizedCategory = category.charAt(0).toUpperCase() + category.slice(1);
      contentElement.textContent = `${capitalizedCategory}: ${displayValue}`;
    } else {
      contentElement.textContent = displayValue;
    }

    return contentElement;
  },

  // Codifica o valor para URL, mas preserva as vírgulas
  // É importante para manter o mesmo padrão de URL que o filtro aplica
  customEncode(value) {
    return encodeURIComponent(value).replace(/%2C/g, ',');
  },

  // Remove o filtro clicado da URL
  removeFilter(filterType, valueToRemove, category) {
    const { filterConfigs, customEncode } = FilteredItems;
    const url = new URL(window.location.href);
    const params = url.searchParams;

    const paramName = filterType === 'tag'
      ? `type_tags[${category}][]`
      : filterConfigs[filterType].urlParam;

    const currentValues = params.getAll(paramName);

    // Filtra os valores, removendo o que foi clicado pelo usuário
    const remainingValues = currentValues.filter(value => {
      if (filterType === 'color') {
        const colorName = value.split('|')[0].trim();
        return colorName !== valueToRemove;
      }
      return value !== valueToRemove;
    });

    // Recria os parâmetros da URL, agora sem o valor removido
    const allParams = [];
    remainingValues.forEach(value => {
      allParams.push(`${paramName}=${customEncode(value)}`);
    });

    for (const [key, value] of params.entries()) {
      if (key !== paramName) {
        allParams.push(`${key}=${customEncode(value)}`);
      }
    }

    const newSearch = allParams.length > 0 ? `?${allParams.join('&')}` : '';
    url.search = newSearch;

    setTimeout(() => {
      window.location.href = url.toString();
    }, 750);
  },

  // Verifica os parâmetros da URL e retorna as infos necessárias para montar a div de itens filtrados
  getFilterInfoFromParam(paramKey, paramValue) {
    const { filterConfigs } = FilteredItems;

    if (paramKey === filterConfigs.color.urlParam) {
      const colorName = paramValue.split('|')[0].split(',')[0].trim();
      return { config: filterConfigs.color, colorName };
    } else if (paramKey === filterConfigs.size.urlParam) {
      return { config: filterConfigs.size, value: paramValue };
    } else if (paramKey.startsWith(filterConfigs.tag.urlParam + '[')) {
      const cleanedCategory = paramKey.match(/type_tags\[([^\]]+)\]/)?.[1];
      if (cleanedCategory) {
        return { config: filterConfigs.tag, value: paramValue, category: cleanedCategory };
      }
    }
    return null;
  },

  init() {
    const { filteredItemsContainer, filterRootElement, loadFiltersFromURL } = FilteredItems;
    if (!filteredItemsContainer || !filterRootElement) return;

    loadFiltersFromURL();
  },
};